class ClaroluzEventError {
    constructor(type: string, message: string) {
        let event = new CustomEvent('claroluz_error', {detail: {type: type, message: message}} as CustomEventInit);
        document.dispatchEvent(event);
    }
}

//removeIf(production)
export default ClaroluzEventError;
//endRemoveIf(production)